import React from "react";
import { useHistory, generatePath } from "react-router-dom";

import { Table, Icon, Button, Message } from "semantic-ui-react";
import Notification from "domain/model/Notification";

import routes from "utils/routes";

import dayjs from "dayjs";

type props = {
  isAgency: boolean;
  storeId: string;
  notifications: Notification[];
};

export const StoreNotificationList: React.FC<props> = ({
  notifications,
  isAgency,
  storeId,
}) => {
  const history = useHistory();

  const notificationShowPath = isAgency
    ? generatePath(routes.agency.notificationShow.pathname, {
        storeId,
      })
    : routes.store.notificationShow.pathname;

  if (notifications.length === 0) {
    return <Message content="お知らせはありません。" />;
  }

  return (
    <Table striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>ID</Table.HeaderCell>
          <Table.HeaderCell>タイトル</Table.HeaderCell>
          <Table.HeaderCell>投稿日時</Table.HeaderCell>
          <Table.HeaderCell>最終更新日時</Table.HeaderCell>
          <Table.HeaderCell>操作</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {notifications.map((notification: Notification, index: number) => {
          return (
            <Table.Row key={index}>
              <Table.Cell>{notification.id}</Table.Cell>
              <Table.Cell>{notification.title}</Table.Cell>
              <Table.Cell>
                {dayjs(notification.createdAt).format("YYYY-MM-DD HH:mm")}
              </Table.Cell>
              <Table.Cell>
                {dayjs(notification.updatedAt).format("YYYY-MM-DD HH:mm")}
              </Table.Cell>
              <Table.Cell>
                {
                  <Button
                    icon
                    onClick={() =>
                      history.push(notificationShowPath, {
                        title: notification.title,
                        content: notification.content,
                      })
                    }
                  >
                    <Icon name="eye" />
                    詳細へ
                  </Button>
                }
              </Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};
